var React = require('react');

function HamburgerButton (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"#202945","key":1},[React.createElement("rect",{"width":"20","height":"2","rx":"1","key":0}),React.createElement("rect",{"y":"6","width":"20","height":"2","rx":"1","key":1}),React.createElement("rect",{"y":"12","width":"20","height":"2","rx":"1","key":2})])]);
}

HamburgerButton.defaultProps = {"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none"};

module.exports = HamburgerButton;

HamburgerButton.default = HamburgerButton;
